export default __webpack_public_path__ + "static/media/instagram.ef15be82.svg";